import { render, staticRenderFns } from "./PendingSubmissionFilter.vue?vue&type=template&id=2b807302&"
import script from "./PendingSubmissionFilter.vue?vue&type=script&lang=js&"
export * from "./PendingSubmissionFilter.vue?vue&type=script&lang=js&"
import style0 from "./PendingSubmissionFilter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports